import produce from "immer";

export const actions = {
  REPORTS_GET_ARTISANS: "REPORTS_GET_ARTISANS",

  REPORTS_GET_ARTISAN: "REPORTS_GET_ARTISAN",

  REPORTS_GET_ARTISANS_SUCCESS: "REPORTS_GET_ARTISANS_SUCCESS",
  REPORTS_GET_ARTISAN_SUCESS: "REPORTS_GET_ARTISAN_SUCESS",

  REPORTS_ARTISANS_IS_LOADING: "REPORTS_ARTISANS_IS_LOADING",
  REPORTS_ARTISANS_COUNT: "REPORTS_ARTISANS_COUNT",
};

const initalState = {
  items: [],
  isLoading: false,
  count: 0,
};

export default produce((draft, action) => {
  const { type, payload } = action;

  if (!draft) return initalState;

  switch (type) {
    case actions.REPORTS_GET_ARTISANS_SUCCESS: {
      draft.items = payload;
      break;
    }

    case actions.REPORTS_ARTISANS_IS_LOADING: {
      draft.isLoading = payload;
      break;
    }

    case actions.REPORTS_ARTISANS_COUNT: {
      draft.count = payload;
      break;
    }

  }
});
